import { render } from "./LivingWageCalculationsTable.vue?vue&type=template&id=15e36f5a"
import script from "./LivingWageCalculationsTable.vue?vue&type=script&lang=js"
export * from "./LivingWageCalculationsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__